/**
 * Created by pyt on 1/18/17.
 */
export const MARK_AS_AUTHENTICATED = 'MARK_AS_AUTHENTICATED';
export const MARK_AS_LOGGED_OUT = 'MARK_AS_LOGGED_OUT';
export const SET_CHOSEN_MEMBERSHIP_TYPE = 'SET_CHOSEN_MEMBERSHIP_TYPE';
export const SET_DEBUG_MODE = 'SET_DEBUG_MODE';
export const UPDATE_API_FEATURES = 'UPDATE_API_FEATURES';
export const UPDATE_BACKGROUND_OPERATIONS = 'UPDATE_BACKGROUND_OPERATIONS';
export const UPDATE_FRESHDESK_TOKEN = 'UPDATE_FRESHDESK_TOKEN';
export const UPDATE_IS_APP_OFFLINE = 'UPDATE_IS_APP_OFFLINE';
export const UPDATE_IS_NEW_VERSION_AVAILABLE = 'UPDATE_IS_NEW_VERSION_AVAILABLE';
export const UPDATE_IS_PUBLIC_ROUTE = 'UPDATE_IS_PUBLIC_ROUTE';
export const UPDATE_MEMBERSHIP = 'UPDATE_MEMBERSHIP';
export const UPDATE_ORIGINAL_ROUTE = 'UPDATE_ORIGINAL_ROUTE';
export const UPDATE_REFRESH_TOKEN = 'UPDATE_REFRESH_TOKEN';
export const UPDATE_TOKEN = 'UPDATE_TOKEN';
export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_USER_PROFILE = 'UPDATE_USER_PROFILE';
export const UPDATE_USER_ROLE = 'UPDATE_USER_ROLE';
